import { type TFunction } from 'i18next';

import { NONE_VALUE } from '../constant';
import { type CategoryNode } from '../types';

export const getNoneNode = (
  type: CategoryNode['type'],
  t: TFunction<'build'>,
): CategoryNode => {
  return {
    nodeId: NONE_VALUE,
    groupId: NONE_VALUE,
    label: t('select.unselect'),
    type,
    subNodes: [],
    name: t('select.unselect'),
  };
};

export const isNodeEmpty = (node?: CategoryNode) => {
  return !node || node.nodeId === NONE_VALUE;
};
